<template>
  <div class="new-share-page" ref="container" v-if="dataReady">
    <spinner v-if="showSpinner" />
    <div class="share-popup" v-if="showPopup">
      <div class="share-popup-inner">
        <button type="button" class="btn-close" @click="showPopup=false">
          <span>x</span>
        </button>
        <button type="button" class="new-btn-share" @click="share()">{{ pageContent.cta_links[2].text }}</button>
        <button type="button" class="new-btn-share" @click="share(false)">{{ pageContent.cta_links[3].text }}</button>
        <button type="button" class="btn-download" @click="save">{{ pageContent.cta_links[4].text }}</button>
      </div>
    </div>
    <div class="share-inner" ref="capture">
      <div class="left-section">
        <img :src="gameContent.logo" alt="game logo" width="36" height="auto" />
        <p class="sub-title">Regluvörður 2024</p>
        <h3 class="name" v-if="userData">{{ userData.name }}</h3>
        <div class="score">
          <span class="txt">Heildarstig af 10.000</span>
          <span class="value">{{ userTotalPoints }}</span>
        </div>
      </div>
      <div class="right-section">
        <img class="share-img" :src="pageContent.image_url" alt="share img" />
      </div>
    </div>
    <div class="btn-wrapper">
      <button type="button" class="btn-cancel" @click="cancel">{{ pageContent.cta_links[0].text }}</button>
      <button type="button" class="new-btn-share" @click="openPopup">{{ pageContent.cta_links[1].text }}</button>
    </div>
  </div>
</template>

<script>
import API from '@/shared/api'
import html2canvas from 'html2canvas'
export default {
  name: 'RegluvardarShare',
  data () {
    return {
      dataReady: false,
      userData: null, 
      fbShareId: null,
      xShareId: null,
      userTotalPoints: 0,
      gameRule: {},
      gameContent: {},
      pageContent: {},
      showSpinner: false,
      showPopup: false,
      isFacebook: true,
      scrollPosition: 0,
    }
  },
  created () {
    if (this.$data.globalData.user) {
      this.userData = this.$data.globalData.user
      this.userTotalPoints = this.userData.user_total_points
    }
    if (this.$data.globalData.gameRule) {
      this.gameRule = this.$data.globalData.gameRule
    }
    if (this.$data.globalData.gameContent) {
      this.gameContent = this.$data.globalData.gameContent
    }
    if (this.$data.globalData.pageContent) {
      this.pageContent = this.$data.globalData.pageContent['deila']
    }
    this.dataReady = true
  },
  mounted () {
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/is_IS/sdk.js#xfbml=1&version=v3.0";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  methods: {
    postToSocialMedia (shareId = '') {
      this.showSpinner = false
      if (this.isFacebook) {
        this.fbShareId = shareId
        window.open(`https://www.facebook.com/sharer.php?u=${this.$data.globalData.hosted_domain}share/${shareId}/`, '_blank')
      } else {
        this.xShareId = shareId
        window.open(`https://twitter.com/share?url=${this.$data.globalData.hosted_domain}share/${shareId}/`, '_blank')
      }
    },
    async convertToImg (isDownload = false) {
      if (isDownload) this.showSpinner = true
      const captureEle = this.$refs.capture
      const containerEle = this.$refs.container
      const clonedEle = captureEle.cloneNode(true)
      if (!isDownload) clonedEle.classList.add('cloned')
      else {
        const shareImgEle = clonedEle.querySelector('.share-img')
        clonedEle.classList.add('cloned', 'twitter')
        shareImgEle.setAttribute('src', this.pageContent.secondary_image)
        const imageLoadPromise = new Promise((resolve, reject) => {
          shareImgEle.onload = () => resolve()
          shareImgEle.onerror = () => reject()
        });
        await imageLoadPromise;
      }

      containerEle.appendChild(clonedEle)

      const width = 1200
      const height = !isDownload ? 630 : 1200

      html2canvas(clonedEle, {
        scale: 4,
        width: width,
        height: height,
        useCORS: true,
        allowTaint: false,
      }).then((canvas) => {
        if (isDownload) {
          const imgUrl = canvas.toDataURL('image/png')
          this.download(imgUrl)
          return
        }
        canvas.toBlob((blob) => {
          const formData = new FormData()
          formData.append('file', blob, 'image.png')
          formData.append('width', width)
          formData.append('height', height)
          API.meInstance.post('/upload-image', formData).then((res) => {
            if (res.data && res.data.image_url) {
              const id = `${res.data.share_id}_${width}x${height}`
              this.postToSocialMedia(id)
            }
          }).catch((err) => {
            console.log(err)
          })
          clonedEle.remove()
        }, 'image/png', 1.0)
      })
    },
    share (isFacebook = true) {
      this.isFacebook = isFacebook
      this.showPopup = false
      this.showSpinner = true
      const shareId = this.fbShareId && isFacebook ? this.fbShareId : this.xShareId
      if (shareId) {
        this.postToSocialMedia(shareId)
        return
      }
      this.convertToImg()
    },
    download (url) {
      if (!url) return
      const a = document.createElement('a')
      a.href = url
      a.download = 'RegluvardarShare.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      this.showSpinner = false
    },
    cancel () {
      this.$router.replace('/leader-board')
    },
    save () {
      this.showPopup = false
      this.convertToImg(true)
    },
    openPopup() {
      this.scrollPosition = window.scrollY;
      this.showPopup = true;
    },
    disableScroll() {
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    },
    enableScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, this.scrollPosition);
    }
  },
  watch: {
    showPopup (newVal) {
      if (newVal) this.disableScroll()
      else this.enableScroll()
    },
    showSpinner (newVal) {
      if (newVal) {
        this.scrollPosition = window.scrollY;
        this.disableScroll()
      } else this.enableScroll()
    },
  },
}
</script>

<style lang="scss" scoped>
.new-share-page {
  padding: 80px 20px;
  .spinner-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.13);
  }
  .share-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    .share-popup-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 40px;
      padding: 20px;
      flex-wrap: wrap;
      .btn-close {
        position: absolute;
        top: calc(var(--mobile-header-height) + 20px);
        right: 20px;
        background: white;
        border: none;
        outline: none;
        font-size: 36px;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0px;
        span {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          top: -10%;
        }
      }
      button {
        height: 50px;
        border-radius: 10px;
        font-weight: 500;
        color: #011627;
        white-space: nowrap;
      }
      .new-btn-share, .btn-download {
        background: #FCBD00;
        border: none;
        min-width: 236px;
        max-width: 400px;
      }
    }
  }
  .share-inner {
    display: flex;
    max-width: 1200px;
    margin: 0 auto 53px;
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    &.cloned {
      position: fixed;
      flex-direction: row;
      bottom: 300%;
      &:not(.twitter) {        
        .left-section {
          flex: 1 0 775px;
        }
        .right-section {
          flex: 1 0 425px;
          .share-img {
            height: 630px;
          }
        }
      }
      &.twitter {
        height: 1200px;
        .left-section {
          padding: 109px 10px 0px;
          flex: 1 0 874px;
          img {
            height: 201px;
            width: 208px;
            margin-bottom: 89px;
          }
          .sub-title {
            font-size: 46px;
            line-height: 32px;
            margin-bottom: 12px;
          }
          .name {
            font-size: 82px;
            margin-bottom: 60px;
            line-height: normal;
          }
          .score {
            .txt {
              font-size: 26px;
              line-height: 22px;
              margin-bottom: 0;
            }
            .value {
              font-size: 300px;
              line-height: 250px;
            }
          }
        }
        .right-section {
          flex: 1 0 326px;
        }
      }
    }

    .left-section {
      position: relative;
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 68px 10px;
      img {
        height: 135px;
        width: 135px;
        margin-bottom: 65px;
      }
      .sub-title {
        font-size: 30px;
        font-weight: 500;
        line-height: 26px;
        margin-bottom: 16px;
      }
      .name {
        margin: 0 0 30px;
        font-size: 54px;
        font-weight: 700;
        line-height: normal;
        text-align: center;
        text-transform: capitalize;
        line-break: anywhere;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        display: -webkit-box;
      }
      .score {
        display: flex;
        align-items: center;
        flex-direction: column;
        .txt {
          font-size: 17px;
          font-weight: 500;
          line-height: 18px;
          margin-bottom: 16px;
        }
        .value {
          font-size: 195px;
          font-weight: 700;
          line-height: 120px;
          color: #FCBD00;
        }
      }
    }

    .right-section {
      .share-img {
        object-fit: cover;
      }
    }
  }
  .btn-wrapper {
    display: flex;
    align-items: center;
    gap: 21px;
    width: fit-content;
    margin: 0 auto;
    button {
      height: 50px;
      border-radius: 10px;
      font-weight: 500;
      color: #011627;
      white-space: nowrap;
    }
    .btn-cancel {
      border: 1.5px solid #FCBD00;
      min-width: 170px;
      background: #FFFFFF;
      box-shadow: 0px 0px 50px 0px #0000001A;
    }
    .new-btn-share, .btn-download {
      background: #FCBD00;
      border: none;
      min-width: 236px;
    }
  }
}
@media screen and (max-width: 1024px) {
  .new-share-page {
    .share-inner:not(.cloned) {
      .left-section {
        padding: 34px 10px;
        img {
          margin-bottom: 40px;
        }
        .sub-title {
          font-size: 22px;
          margin-bottom: 10px;
        }
        .name {
          font-size: 40px;
        }
        .score {
          .txt {
            font-size: 16px;
          }
          .value {
            font-size: 146px;
            line-height: 96px;
          }
        }
      }
      .right-section {
        .share-img {
          width: 350px;
        }
      }
    }
  }
}
@media screen and (max-width: 950px) {
  .new-share-page {
    .share-inner:not(.cloned) {
      .right-section {
        .name {
          font-size: 36px;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .new-share-page {
    padding-top: calc(var(--mobile-header-height) + 20px);
    .share-popup {
      .share-popup-inner {
        flex-direction: column;
        gap: 20px;
      }
    }
    .btn-wrapper {
      justify-content: space-between;
      button {
        height: auto;
      }
      .new-btn-share, .btn-cancel, .btn-download {
        min-width: 150px;
        flex-basis: fit-content;
        padding: 10px 15px;
      }
    }
    .share-inner:not(.cloned) {
      flex-direction: column;
      margin-bottom: 20px;
      .left-section {
        padding-bottom: 80px;
      }
      .right-section {
        .share-img {
          width: 100%;
        }
      }
    }
    .btn-wrapper {
      flex-direction: column;
      width: 100%;
    }
  }
}
</style>